import React from 'react'
import { IconArrowBackUp, IconArrowForwardUp } from '@tabler/icons-react'
import classNames from 'classnames'

import { Button } from '@/components/buttons/Button'

import './SkipButton.scss'

export const SkipButton = ({ modifier, isForwardSkip, handleSkip, isDisabled }) => {
  return (
    <Button
      circular
      small
      aria-label={
        isForwardSkip ? `Skip Forward ${modifier} Seconds` : `Skip Backwards ${modifier} Seconds`
      }
      className={classNames('skip-button', { disabled: isDisabled })}
      disabled={isDisabled}
      tooltip={
        isForwardSkip ? `Skip Forward ${modifier} Seconds` : `Skip Backwards ${modifier} Seconds`
      }
      onClick={handleSkip}
    >
      <div className={classNames('skip-arrow', { 'forward-skip-arrow': isForwardSkip })}>
        {isForwardSkip ? <IconArrowForwardUp /> : <IconArrowBackUp />}
      </div>
      <div
        className={classNames('skip-seconds-text', { 'forward-skip-text': isForwardSkip })}
      >{`${modifier}`}</div>
    </Button>
  )
}
